/*
 * @Description: 
 * @Author: zml
 * @Date: 2023-04-19 19:42:50
 * @LastEditors: zml
 * @LastEditTime: 2023-04-27 14:04:38
 */
import Vue from 'vue'
import Vuex from 'vuex'
import tenant from './modules/tenant'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        tenant
    }
})
